import React, { useState, useEffect } from 'react';
import { db } from '../firebase'; // تأكد من أن Firebase مُعد بشكل صحيح
import { collection, getDocs } from 'firebase/firestore';
import { Link } from 'react-router-dom';


const OffersPage = () => {
  const [offers, setOffers] = useState([]);
  const [filteredOffers, setFilteredOffers] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCountry, setSelectedCountry] = useState('');
  const [selectedCity, setSelectedCity] = useState('');
  const [selectedType, setSelectedType] = useState('');

  const tripTypes = ['رحلة', 'رحلة حلال', 'حج و عمرة']; // أنواع الرحلات المحددة مسبقاً

  useEffect(() => {
    const fetchOffers = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'offers'));
        const offersData = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setOffers(offersData);
        setFilteredOffers(offersData); // تهيئة العروض المصفاة
      } catch (error) {
        console.error('خطأ في جلب العروض:', error);
      }
    };

    fetchOffers();
  }, []);

  // تصفية العروض بناءً على البحث والفلاتر المحددة
  useEffect(() => {
    const filtered = offers.filter((offer) => {
      const matchesSearch = offer.name.toLowerCase().includes(searchQuery.toLowerCase());
      const matchesCountry = !selectedCountry || offer.country === selectedCountry;
      const matchesCity = !selectedCity || offer.city === selectedCity;
      const matchesType = !selectedType || offer.type === selectedType;

      return matchesSearch && matchesCountry && matchesCity && matchesType;
    });
    setFilteredOffers(filtered);
  }, [searchQuery, selectedCountry, selectedCity, selectedType, offers]);

  const countries = [...new Set(offers.map((offer) => offer.country))];
  const cities = [...new Set(offers.filter((offer) => offer.country === selectedCountry).map((offer) => offer.city))];

  return (
    <div className="min-h-screen bg-gradient-to-r from-[#0B4B41] to-[#26B75D] py-12 px-6">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-4xl font-bold text-white text-center mb-8">عروض الوكالات</h1>

        {/* الفلاتر والبحث */}
        <div className="bg-white p-6 rounded-lg shadow-lg mb-8">
          <div className="flex flex-wrap gap-4 justify-between">
            {/* شريط البحث */}
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="ابحث عن العروض..."
              className="flex-grow px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[rgb(0,176,176)]"
            />

            {/* فلتر البلد */}
            <select
              value={selectedCountry}
              onChange={(e) => setSelectedCountry(e.target.value)}
              className="px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[rgb(0,176,176)]"
            >
              <option value="">اختر البلد</option>
              {countries.map((country, index) => (
                <option key={index} value={country}>
                  {country}
                </option>
              ))}
            </select>

            {/* فلتر المدينة */}
            <select
              value={selectedCity}
              onChange={(e) => setSelectedCity(e.target.value)}
              disabled={!selectedCountry} // يتم تعطيله إذا لم يتم اختيار بلد
              className="px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[rgb(0,176,176)]"
            >
              <option value="">اختر المدينة</option>
              {cities.map((city, index) => (
                <option key={index} value={city}>
                  {city}
                </option>
              ))}
            </select>

            {/* فلتر نوع الرحلة */}
            <select
              value={selectedType}
              onChange={(e) => setSelectedType(e.target.value)}
              className="px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[rgb(0,176,176)]"
            >
              <option value="">اختر نوع الرحلة</option>
              {tripTypes.map((type, index) => (
                <option key={index} value={type}>
                  {type}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* شبكة العروض */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredOffers.length === 0 ? (
            <p className="col-span-full text-center text-lg text-white">
              لم يتم العثور على عروض. جرب تعديل البحث أو الفلاتر.
            </p>
          ) : (
            filteredOffers.map((offer) => (
              <div
                key={offer.id}
                className="bg-white p-10 rounded-lg shadow-lg hover:shadow-xl transition"
              >
                <img
                  src={offer.image}
                  alt={offer.name}
                  className="w-full h-48 object-cover rounded-lg mb-4"
                />
                <h2 className="text-xl font-bold text-gray-800">{offer.name}</h2>
                <p className="text-gray-600">
                  {offer.type}, {offer.city}, {offer.country}
                </p>
                <p className="text-lg font-semibold text-[rgb(0,176,176)] mt-2">دج{offer.price}</p>
                <p className="text-gray-700 mt-2">{offer.description}</p>
                <div className='flex justify-center items-center flex-col w-full h-max pt-4'>
                  <Link
                  className=" bg-[#26B75D] text-white px-4 py-2  rounded-lg hover:bg-[#047857]"
                  to={`/OffersPage/${offer.id}`}
                  >
                    عرض التفاصيل
                  </Link>
                </div>
                
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default OffersPage;
